// Shared owner-counted body scroll lock.
//
// Three components used to save and restore `document.body.style.overflow`
// independently, so two overlapping drawers traded restores: closing the first
// wrote back the pre-lock value while the second was still open (the page
// scrolled behind it), and closing the second then wrote back 'hidden' and froze
// the page until a reload. The page styles are now captured once, when the first
// owner locks, and restored once, when the last owner releases.
//
// Each caller gets its own handle so a lock cannot be released by anyone else.

let depth = 0
let savedOverflow = ''
let savedPadRight = ''

export function createScrollLock () {
  let held = false

  return {
    lock () {
      if (held) return
      held = true

      if (depth === 0) {
        savedOverflow = document.body.style.overflow
        savedPadRight = document.body.style.paddingRight
        // Pad by the scrollbar width so hiding it does not shift the layout.
        const sbw = window.innerWidth - document.documentElement.clientWidth
        document.body.style.overflow = 'hidden'
        if (sbw > 0) document.body.style.paddingRight = sbw + 'px'
      }

      depth += 1
    },

    // Safe to call from beforeDestroy on an owner that never locked: without the
    // `held` guard that case restored an empty string over another owner's lock.
    unlock () {
      if (!held) return
      held = false
      depth -= 1

      if (depth === 0) {
        // Restored verbatim — an empty string must stay an empty string, so no
        // `|| ''` coercion here.
        document.body.style.overflow = savedOverflow
        document.body.style.paddingRight = savedPadRight
      }
    }
  }
}
